import {useOptimisticData} from '@github-ui/optimistic-connection/useOptimisticData'
import {useQuery} from '@github-ui/react-query'

import {fetchSubscriptionStatus, type SubscriptionStatus, subscriptionStatusQueryKey} from './fetch-subscription-status'

export function useSubscriptionStatus(owner: string, repo: string, number: number, initialData: SubscriptionStatus) {
  const queryKey = subscriptionStatusQueryKey(owner, repo, number)
  const {data} = useQuery({
    queryKey,
    queryFn: ({signal}) => fetchSubscriptionStatus(owner, repo, number, signal),
    initialData,
    // Seed from the parent and refresh only on explicit invalidation (including Alive events).
    staleTime: Infinity,
  })
  return useOptimisticData(data, {
    targets: [{queryKey}],
  })
}
